import OriginTable from './Table';

export type TableProps = typeof OriginTable & {};
const Table = OriginTable as TableProps;

export { Table };
